import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 22a10 10 0 110-20 10 10 0 010 20zm-1-6l7.07-7.07-1.41-1.42L11 13.18l-2.83-2.83-1.41 1.42L11 16z"/>
  </SvgIcon>
);